const ITEMS = [
    "HOTELS",
    "RESTAURANTS",
    "REAL ESTATE",
    "SHOWROOMS",
    "HOSPITALS",
    "SCHOOLS",
    "GYMS & SPAS",
    "OFFICES",
    "FACTORIES",
];

export default function Marquee({ reverse = false }) {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            className="relative overflow-hidden border-y border-[#00C6FF]/15 bg-[#0A1F44]/30 py-5"
            data-testid="editorial-marquee"
        >
            <div
                className="marquee-track flex w-max items-center gap-10"
                style={reverse ? { animationDirection: "reverse" } : undefined}
            >
                {row.map((item, i) => (
                    <span key={i} className="flex items-center gap-10">
                        <span className="whitespace-nowrap text-sm font-semibold uppercase tracking-[0.35em] text-slate-400">
                            {item}
                        </span>
                        <span className="text-[#00C6FF]">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
}
